// extracted by mini-css-extract-plugin
module.exports = {"pos-modal-root":"pos-modal-root___2s7QE"};